import mq from '../../../../../commons/styles/mediaQueries';
import { progressiveLoading } from '../../../../../commons/styles/animations';
import styled from '../../../../../theme/styled';
import { ParsedTransaction, TransactionStatus } from '../../../../../../typings/transaction';
import { ORDER_STATUS } from '../../../../../commons/utils/constants';

const Block = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

interface StatusStyledProps {
  transaction: ParsedTransaction;
}

const isStatusError = (status: TransactionStatus | undefined) =>
  status === ORDER_STATUS.REFUND_SENT ||
  status === ORDER_STATUS.REFUND_FAILED ||
  status === ORDER_STATUS.REFUND_REQUESTED;

const isStatusAccepted = (status: TransactionStatus | undefined) =>
  status === ORDER_STATUS.PAYOUT_REQUESTED ||
  status === ORDER_STATUS.PAYOUT_PENDING ||
  status === ORDER_STATUS.PAYOUT_SENT;

const Status = styled.div<StatusStyledProps>`
  background-color: ${({ theme, transaction }) => {
    const status = transaction?.status;

    if (status && isStatusError(status)) {
      return theme.colors.bgError;
    }

    if (status && isStatusAccepted(status)) {
      return theme.colors.bgAccepted;
    }

    return theme.colors.bgInfo;
  }};
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.sizes.m};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  min-height: 14px;
  margin: 15px 16px;
  padding: 10px;
  text-align: center;
  border-radius: 4px;

  &:empty {
    ${({ theme }) =>
    progressiveLoading({
      primaryColor: theme.colors.bgInfo,
      secondaryColor: theme.colors.yellowLight,
    })}
  }

  ${mq.desktop} {
    margin: 15px 0;
  }
`;

const StatusInfo = styled.div`
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 15px 16px;

  ${mq.desktop} {
    margin: 15px 0;
  }
`;

const StatusInfoText = styled.div`
  margin-left: 10px;
  font-size: ${({ theme }) => theme.sizes.m};
`;

const StatusLoading = styled.div`
  ${progressiveLoading()}
  padding: 18px;
  width: 100%;
`;

const StatusInfoIcon = styled.div`
  height: 24px;
  width: 24px;
`;

const AdditionalLink = styled.a`
  color: ${({ theme }) => theme.colors['text-global-highlight']};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  text-decoration: none;
  cursor: pointer;
`;

export default {
  Block,
  Status,
  StatusInfo,
  StatusInfoText,
  StatusLoading,
  StatusInfoIcon,
  AdditionalLink,
};
